import { has } from "lodash";

/*
 * Prepare files to save in the database.
 * Do not save uppyId, uploadedByInfo and progress properties. 2 of them is objects and BE does not support saving objects.
 */
export const prepareFilesToSave = (files) => {
	return files.map(
		(file) => {
			return {
				completedAt: file.completedAt,
				createdAt: file.createdAt,
				downloadUrl: file.downloadUrl,
				finalizedAt: file.finalizedAt,
				id: file.id,
				uppyId: file.uppyId,
				name: file.name,
				size: file.size,
				status: file.status,
				type: file.type,
				uploadedBy: file.uploadedBy,
				uploadMetadataId: file.uploadMetadataId,

				// this fields required for flowable BE
				created: file.createdAt,
				createdBy: file.uploadedBy,
				uploadedOn: file.completedAt,
				tenantId: file.tenantId,
			};
		},
	);
};

export const mergeFileArrays = (array1 = [], array2 = []) => {
	return [
		...array1
			.concat(array2)
			.reduce(
				(acc, file) => {
					let mergedObject = Object.assign(acc.get(`${file.size}_${file.name}`) || {}, file);
					mergedObject.size = Number(mergedObject.size);

					// remove to not display data who uploaded the file
					delete mergedObject.uploadedByInfo;

					// check if an object has a scopeId property associated with flowable file object
					if (has(mergedObject, "scopeId")) {
						mergedObject = {
							id: file.id,
							name: file.name,
							size: Number(file.size),
							createdAt: file.created,
							uploadedBy: file.lastModifiedBy,
							downloadUrl: file.downloadUrl,
							completedAt: file.lastModified,
						};
					}

					return acc.set(`${file.size}_${file.name}`, mergedObject);
				},
				new Map(),
			).values(),
	];
};

export const extendFileObjectsForFlowableInput = (files) => {
	return files.map((f) => {
		if (!f.id) {
			f.status = 6;
		}

		if (f.completedAt) {
			f.status = undefined;

			if (f.finalizedAt === null) {
				f.status = 3;
			}
		}

		if (f.uploadMetadataId) {
			f.downloadUrl = `platform://${f.uploadMetadataId}`;
		}

		return f;
	});
};
